import React from "react";
import { Flame, ShieldCheck } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AdminLogin = () => {
  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/admin/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 ember-bg">
      <div className="w-full max-w-md bento-card !p-10 text-center" data-testid="admin-login-card">
        <span className="glow-blob" />
        <div className="icon-badge !h-14 !w-14 mx-auto mb-6">
          <Flame className="h-7 w-7 text-[#F28C18]" strokeWidth={1.5} />
        </div>
        <div className="overline mb-2">RFMG Admin</div>
        <h1 className="font-serif-display text-4xl text-[#F6F0E6]">
          The <span className="italic gold-text">Inner Court</span>
        </h1>
        <p className="mt-4 text-[#D9D9D9] text-[15px] leading-relaxed">
          This area is reserved for covenant leadership. Sign in with the ministry Google
          account to access the dashboard, recordings, donations, and push broadcasts.
        </p>
        <button onClick={handleLogin} className="btn-fire w-full mt-8" data-testid="admin-google-signin">
          <ShieldCheck className="h-4 w-4" strokeWidth={1.7} />
          Sign in with Google
        </button>
        <p className="mt-6 text-[11px] tracking-[0.22em] uppercase text-[#C9A44C]/70">
          Authorised emails only · revivalfireteam@gmail.com
        </p>
        <a href="/" className="mt-8 inline-block text-sm text-[#D9D9D9]/70 hover:text-[#C9A44C] transition-colors" data-testid="admin-back-public">
          ← Back to public site
        </a>
      </div>
    </div>
  );
};

export default AdminLogin;
